import { useContext } from "react";
import { LanguageContext } from "../contexts/languageContext";
import type { LanguageContextType } from "../types/LanguageType";

const useTranslation = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  };
  return context;
};

export default useTranslation;